<template>
  <el-select
    placeholder="监听状态查询"
    v-model="botId"
    class="panel-header"
    clearable
    @change="selectChange"
  >
    <el-option
      v-for="(item,index) in wxList"
      :key="index"
      :label="item.botName"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { mapGetters } from 'vuex'
import {queryBotList} from "@/api/wechat/wechatPanel";
export default {
  name: "queryHeader",
  data() {
    return {
      botId: '',
      wxList: [],
    }
  },
  computed: {
    ...mapGetters(['realMobile']),
  },
  created(){
    this.getBotList();
  },
  methods: {
    selectChange(){
      this.$emit('toQuery',this.botId);
    },
    getBotList(){
      queryBotList({
        page: 1,
        limit: 100,
        botStatus: 1,
      }).then((res) => {
        this.wxList = res.page.list
        if(this.wxList && this.wxList.length){
          this.botId = this.wxList[0].id
          this.selectChange();
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px){
  .panel-header {
    position: absolute;
    z-index: 99;
    right: 20px;
    top: 10px;
    width: 180px;
  }
}
@media screen and (max-width: 768px){
  .panel-header {
    width: 100%;
    margin-bottom: 10px;
  }
}
</style>
